import useJwt from '@/auth/jwt/useJwt'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

//var tokenJWT =  localStorage.getItem('accessToken')
//axiosIns.defaults.headers.common['Authorization'] = "`Bearer ${ tokenJWT }`"

const responseHandler = response => {

    if(response.headers?.authorization){
       const newToken = response.headers.authorization.split(' ')[1]
       useJwt.setToken(newToken)
    }

    return response;
};

const errorHandler = error => {
   const originalRequest = error.config

   if (error.response.status === 401) {
      if(error.config.url.includes("www.migros")){
         if(error.response.data['leshop-error'] == 'expiredtoken'){
            localStorage.removeItem('tokenMigros')
            //return originalRequest
         }
      }

      if(error.response.data && error.response.data.message == 'Not valid payment status!'){
         window.location.href = error.response.data.url;
      }
      //   localStorage.removeItem('accessToken')
      //   localStorage.removeItem('userData')
    }

    return Promise.reject(error);
};

axiosIns.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
 );

export default axiosIns
